import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import moment from 'moment';
import LandmanBillInfo from 'src/models/personnel/LandmanBillInfo';

interface IDefaultBillHistoryDialogProps {
    dialogName: string;
    defaultBillHistory: Array<LandmanBillInfo>;
    hideDialog: () => void;
}

const DefaultBillHistoryDialog = (props: IDefaultBillHistoryDialogProps) => {
    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('DefaultBillHistoryDialog onCreate()', props.defaultBillHistory);
    };

    const OKClicked = () => {
        props.hideDialog();
    };

    const getBillByValue = (value: string) => {
        switch (value) {
            case 'D':
                return 'Day';
            case 'H':
                return 'Hour';
            case 'M':
                return 'Month';
            default:
                return 'Unknown';
        }
    };

    return (
        <Dialog title="Default Bill Rate History" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ maxHeight: '75%', width: '65%' }}>
            {props.defaultBillHistory?.length > 0 && <div>
                <div style={{ overflowY: 'scroll', maxHeight: '25rem' }}>
                    <table style={{ width: '100%' }}>
                        <thead>
                            <tr style={{background: '#d6d6d6'}}>
                                <th style={{ width: '10%' }}>Bill By</th>
                                <th style={{ width: '15%' }}>Bill Rate</th>
                                <th style={{ width: '15%' }}>Eff Date</th>
                                <th style={{ width: '10%' }}>Manager</th>
                                <th style={{ width: '25%' }}>Manager Name</th>
                                <th style={{ width: '10%' }}>Prev Bill By</th>
                                <th style={{ width: '15%' }}>Prev Bill Rate</th>
                            </tr>
                        </thead>
                        {props.defaultBillHistory?.map((bill: LandmanBillInfo, index: number) => {
                            return (
                                <tbody key={index}>
                                    <tr className={`contract-bill-history-active-item-${index}`}>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {parseFloat(bill.billRate?.toString()).toFixed(2)}
                                        </td>
                                        <td style={{ width: '15%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {getBillByValue(bill.billUnit)}
                                        </td>
                                        <td style={{ width: '15%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {moment(bill.effDate).format('YYYY-MM-DD') as unknown as Date}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {bill.mgrNo}
                                        </td>
                                        <td style={{ width: '25%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {bill.tsdUser}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {getBillByValue(bill.prevUnit)}
                                        </td>
                                        <td style={{ width: '15%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {parseFloat(bill.prevRate?.toString()).toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>
                            );
                        })}
                    </table>
                </div>
            </div>}
            {(!props.defaultBillHistory || props.defaultBillHistory.length === 0) && (
                <div className="bold-centered">No Default Bill History</div>
            )}
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center', textAlign: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Close'}
                    onClick={() => OKClicked()}
                />
            </div>
        </Dialog>
    );
};

export default DefaultBillHistoryDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/pay/DefaultBillHistoryDialog.tsx